const status_list = ['', '导购', '编外']

export function initFinderConfig (ctx) {
  let that = ctx
  if (!that) return console.error('finder初始化未接收到绑定上下文')
  return {
    requestUrl: process.env.VUE_APP_BASE_API + '/commission/record-lists/',
    columns: [
      {
        name: '子订单号',
        key: 'sub_oid'
      },
      {
        name: '订单商品',
        key: 'item_name'
      },
      {
        name: '数量',
        key: 'num',
        width: '100'
      },
      {
        name: '订单支付时间',
        key: 'pay_time'
      },
      {
        name: '订单状态',
        key: 'order_status_des'
      },
      {
        name: '订单实付金额(元)',
        key: 'performance',
        render: (h, { row }) => {
          // jsx语法支持单元格渲染
          return <div> {row.payed_fee / 100} </div>
        }
      },
      {
        name: '所得业绩(元)',
        key: 'performance',
        render: (h, { row }) => {
          // jsx语法支持单元格渲染
          return <div> {row.performance / 100} </div>
        }
      },
      {
        name: '提成比例',
        key: 'abnormal_commisson',
        width: '100',
        render: (h, { row }) => {
          // jsx语法支持单元格渲染
          return <div> {row.commission_proportion}% </div>
        }
      },
      {
        name: '提成(元)',
        key: 'confirmed_commisson',
        render: (h, { row }) => {
          // jsx语法支持单元格渲染
          return <div> {row.commission_fee / 100} </div>
        }
      }
    ],
    actions: [
      {
        name: '导出提成',
        key: 'create',
        slot: 'header',
        type: 'button',
        buttonType: 'primary',
        action: {
          handler: () => {
            that.$exportList({
              filesType: 16,
              exportDate: 'month',
              isDateSingle: true,
              showSettlementStatus: true,
              addParams: {
                salesperson_id: +that.$route.params.id
              }
            })
          }
        }
      }
    ],
    setting: {
      search: [
        {
          type: 'input',
          key: 'oid',
          name: '订单号',
          size: 'medium',
          placeholder: '请输入订单号'
        },
        {
          type: 'input',
          key: 'item_bn',
          name: '货号',
          size: 'medium',
          placeholder: '请输入货号'
        }
      ]
    }
  }
}

export default initFinderConfig
